module.exports = __webpack_public_path__ + "static/media/112.9c62c9a6.png";